import ServiceBase from '../ServiceBase';

export default class CommentsAdminService extends ServiceBase {

    getReportedComments(filters = {}, pageIndex = 0) {
        const params = {
            pageIndex,
            ...filters,
        };
        return this.request('post', 'admin/comments/searchReportedComments', params);
    }

    updateCommentApproval(commentID, moderationActionType, reviewerID) {
        return this.request('post', 'admin/comments/updateCommentApproval', { commentID, moderationActionType, reviewerID });
    }

    searchComments(creatorID, projectID = null, filters = {}, pageSize = null, pageIndex = null) {
        const params = {
            projectID,
            creatorID,
            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('post', 'admin/comments/searchComments', params);
    }

    getDashboardComments(projectID) {
        return this.request('get', 'admin/comments/getDashboardComments', { projectID });
    }

    updateCommentLanguage({
        commentID,
        creatorID,
        languageID,
        projectID = null,
    }) {
        return this.request('post', 'admin/comments/updateCommentLanguage', {
            commentID,
            creatorID,
            languageID,
            projectID,
        });
    }

    deleteAllUserComments(userID) {
        return this.request('post', 'admin/comments/bulkDeleteComments', { authorUserID: userID });
    }
}